(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ghs-custom-filters"] && !Shopify.designMode) return;
  try {
    (function () {
    /* Restore checked states from URL params after page navigation */
    function syncGhsFilters() {
      var params = new URLSearchParams(window.location.search);
      document.querySelectorAll('input[id^="ghs-effect-"], input[id^="ghs-type-"]').forEach(function (input) {
        var values = params.getAll(input.name);
        input.checked = values.indexOf(input.value) !== -1;
      });
    }

    /* Update count badge on each filter-group header */
    function updateFilterBadges() {
      document.querySelectorAll('.facets__panel').forEach(function (panel) {
        var checked = panel.querySelectorAll('input[type="checkbox"]:checked').length;
        var label = panel.querySelector('.facets__label');
        if (!label) return;
        var badge = label.querySelector('.ghs-filter-badge');
        if (checked > 0) {
          if (!badge) {
            badge = document.createElement('span');
            badge.className = 'ghs-filter-badge';
            badge.setAttribute('aria-label', checked + ' selected');
            label.appendChild(badge);
          }
          badge.textContent = checked;
        } else {
          if (badge) badge.remove();
        }
      });
    }

    function init() {
      syncGhsFilters();
      updateFilterBadges();
      document.querySelectorAll('input[id^="ghs-effect-"], input[id^="ghs-type-"]').forEach(function (input) {
        input.addEventListener('change', updateFilterBadges);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
